<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
       <div class="rental-row">
      <div class="card  m-lg-3">
        <div class="card-body ">
          <div class="row mb-md-4 align-items-center form-header">
            <div class="col mt-4">
              <h4 class="ms-lg-4 ms-md-2">Add Vendor Details</h4>
            </div>
           
            <div class="col-12 col-sm-6 col-md-4 d-flex justify-content-end ">
              <llp-button
                classNames="btn-secondary new-btn d-none d-sm-block"
                @click="BackToServices()"
              >
                Back To Vendor Payments
              </llp-button>
               <llp-button
                classNames="btn-secondary new-btn d-block d-sm-none add-btn"
                @click="BackToServices()"
              >
                Go Back
              </llp-button>
            </div>
          </div>

           <div class="col-lg-8 col-md-12 col-sm-12  m-lg-4 m-md-2">
              <div class="card p-4">
           
              <div class="row"> 
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  <llp-label id="nameId" :aria-label="name">Name:</llp-label>
                  <llp-input
                    id="nameInput"
                    v-model="name"
                    class="w-100"
                    autocomplete="off"
                    :errors="validator.name.$errors"
                  ></llp-input>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  <llp-label id="mobile" :aria-label="Lastname"
                    >Mobile:</llp-label
                  >
                  <llp-input
                    id="mobileInput"
                    v-model="mobile"
                    class="w-100"
                    autocomplete="off"
                    :errors="validator.mobile.$errors"
                  ></llp-input>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  <llp-label id="panId" :aria-label="name"
                    >Pan Number:</llp-label
                  >
                  <llp-input
                    id="PanInput"
                    v-model="pan"
                    class="w-100"
                    autocomplete="off"
                    :errors="validator.pan.$errors"
                  ></llp-input>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  <llp-label id="AddressId" :aria-label="Lastname"
                    >Address:</llp-label
                  >
                  <llp-input
                    id="AddressInput"
                    v-model="address"
                    class="w-100"
                    autocomplete="off"
                  ></llp-input>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  <llp-label id="agreementId" :aria-label="name"
                    >Invoice (Document):</llp-label
                  >
                  <!-- File Upload Input for Documents -->
                  <input
                    type="file"
                    id="InvoiceInput"
                    @change="handleFileUpload"
                    class="form-control w-100"
                  />
                    <div v-if="validator.agreement.$error" class="text-danger">
                      <p>{{ validator.agreement.$errors[0].$message }}</p>
                    </div>
                  <!-- Error handling for file validation -->
                  <div v-if="fileError" class="text-danger">{{ fileError }}</div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                  <llp-label id="monthlyRentId" :aria-label="Lastname"
                    >Amount:</llp-label
                  >
                  <llp-input
                    id="MonthlyRentInput"
                    v-model="monthlyRent"
                    class="w-100"
                    autocomplete="off"
                    :errors="validator.monthlyRent.$errors"
                  ></llp-input>
                </div>
              </div>
               <h5 class="mt-2 fw-bold bank-details">Vendor Bank Details</h5>
                  <div class="col-lg-12 col-md-12 col-sm-12 mt-4">
                    <div class="card mb-4">
                      <div class="card-body">
                   <div class="row">
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="accountNumber" :aria-label="AccountNumber"
                      >Account Number:</llp-label
                    >
                    <llp-input
                      id="MonthlyRentInput"
                      v-model="accountNumber"
                      class="w-100"
                      autocomplete="off"
                      :errors="validator.accountNumber.$errors"
                    ></llp-input>
                  </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="pincodeLabel" :aria-label="name"
                      >Account Holder Name:</llp-label
                    >
                    <llp-input
                      id="accountName"
                      class="w-100"
                      autocomplete="off"
                      v-model="accountHolderName"
                      :errors="validator.accountHolderName.$errors"
                    ></llp-input>
                  </div>
              </div>
              <div class="row">
                 <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="BankName" :aria-label="Firstname"
                      >Bank Name:</llp-label
                    >
                    <Dropdown
                      id="BankNameId"
                      v-model="bankName"
                      :options="bankData"
                      optionLabel="bank_name"
                      placeholder="Select your bank name"
                         class="form-control select-dropdown bbps-service-dropdown mobile-optimized-dropdown"

                      @change="onBankSelect"
                      filter
                      filterBy="bank_name"
                    >
                      <template #value="slotProps">
                        <div
                          v-if="slotProps.value"
                          class="flex align-items-center"
                        >
                          <div class="bank-options text-truncate">
                            {{ slotProps.value.bank_name }}
                          </div>
                        </div>
                        <span v-else>Select your bank name</span>
                      </template>

                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div class="dropdown-option-text">
                            {{ slotProps.option.bank_name }}
                          </div>
                        </div>
                      </template>
                    </Dropdown>
                    <div v-if="validator.bankName.$error" class="text-danger">
                      <p>{{ validator.bankName.$errors[0].$message }}</p>
                    </div>
                  </div>
             
                    <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="IFSCCodeLabel" :aria-label="ifscCode"
                      >IFSC Code:</llp-label
                    >
                    <select
                      v-if="availableIfscCodes.length > 0"
                      id="ifscCodeId"
                      class="form-control select-dropdown"
                      v-model="ifscCode"
                    >
                      <option value="">Select your IFSC code</option>
                      <option
                        v-for="code in availableIfscCodes"
                        :key="code"
                        :value="code"
                      >
                        {{ code }}
                      </option>
                    </select>
                    <!-- Input field shown when no IFSC codes available -->
                    <llp-input
                      v-else
                      id="ifscCodeInput"
                      v-model="ifscCode"
                      class="w-100"
                      autocomplete="off"
                    ></llp-input>
                    <div v-if="validator.ifscCode.$error" class="text-danger">
                      <p>{{ validator.ifscCode.$errors[0].$message }}</p>
                    </div>
                  </div>
              </div>
                <div class="row">
                   
                  <div class="col-lg-6 col-md-6 col-sm-12 mb-2">
                    <llp-label id="branch" :aria-label="Branch"
                      >Branch:</llp-label
                    >
                    <llp-input
                      id="MonthlyRentInput"
                      v-model="branch"
                      class="w-100"
                      autocomplete="off"
                      :errors="validator.branch.$errors"
                    ></llp-input>
                  </div>
                  <!-- Show the Bank Branch dropdown only if a bank is selected -->
                 
                </div>
                      </div>
                    </div>
                  </div>
              <div class="row">
                <div class="col-lg-2 col-sm-6 col-md-4">
                  <llp-button
                    :load-spinner="showaddadminSpinner"
                    classNames="btn-secondary new-btn"
                    @click="submitRentalPayment()"
                  >
                    Submit
                  </llp-button>
                </div>
              </div>
           
          </div>
           </div>
        </div>
      </div>
       </div>
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import { helpers, required, numeric, maxLength } from "@vuelidate/validators";
import ErrorService from "../../../services/error.service";
import { useVuelidate } from "@vuelidate/core";
import NetworkService from '@/services/network.service';
import Dropdown from "primevue/dropdown";

export default {
  setup: () => ({ validator: useVuelidate() }),
  components: {
    Dropdown,
  },
  data() {
    return {
      name: "",
      mobile: "",
      pan: "",
      address: "",
      agreement: null,  
      monthlyRent: "",
      fileError: "",
       accountNumber: "",
      bankName: "",
      accountHolderName: "",
      ifscCode: "",
      branch:"",
         availableIfscCodes: {},
      bankData: [],
      showaddadminSpinner:false,
        serviceId:this.$route.params.serviceId,
      userId:localStorage.getItem('User_id')
    };
  },
  validations() {
    return {
      name: { required: helpers.withMessage("Name is required.", required),
         alphaOnly: helpers.withMessage(
          "Name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
       },
      mobile: {
        required: helpers.withMessage("Mobile number is required.", required),
        numeric: helpers.withMessage("Mobile number must be numeric.", numeric),
        maxLength: helpers.withMessage(
          "Mobile number must be 10 digits.",
          maxLength(10)
        ),
        validMobile: helpers.withMessage(
          "Mobile number must start with 6, 7, 8, or 9.",
          (value) => (value ? /^[6789]\d{9}$/.test(value) : true)
        ),
      },
        bankName: {
        required: helpers.withMessage("Bank name is required.", required),
      },
      accountNumber: {
        required: helpers.withMessage("Account number is required.", required),
         numericOnly: helpers.withMessage(
          "Account number should contain only numbers.",
          (value) => /^\d+$/.test(value)
        ),
      },
      accountHolderName: {
        required: helpers.withMessage(
          "Account holder name is required.",
          required
        ),
         alphaOnly: helpers.withMessage(
          "Account holder name should contain only characters.",
          (value) => /^[A-Za-z\s]+$/.test(value)
        ),
      },
      ifscCode: {
        required: helpers.withMessage("Ifsc code is required.", required),
        alphanumeric: helpers.withMessage(
          "IFSC code should contain only characters and numbers.",
          (value) => /^[A-Za-z0-9]+$/.test(value)
        ),
      },
      branch:{
        required: helpers.withMessage("Branch is required.", required),
        alphaOnly: helpers.withMessage(
    "Branch name must contain only characters.",
    (value) => (value ? /^[A-Za-z\s]+$/.test(value) : true)
  ),
      },
      pan: {
        required: helpers.withMessage("PAN Number is required.", required),
        validPAN: helpers.withMessage(
          "PAN must be in format(e.g. ABCDE1234F)",
          (value) =>
            value ? /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value.toUpperCase()) : true
        ),
      },
      agreement: {
        required: helpers.withMessage("Invoice is required.", required),
      },
      monthlyRent: {
        required: helpers.withMessage("Monthly rent is required.", required),
          numericOnly: helpers.withMessage(
          "Monthly rent must be a valid number.",
          (value) => /^(\d+(\.\d{1,2})?)$/.test(value)
        ),
      },
    };
  },
   mounted() {
    this.fetchBankDetail();
  },
  methods: {
    BackToServices() {
      this.$router.back();
    },

    handleFileUpload(event) {
  const file = event.target.files[0];
  const allowedTypes = [
    "image/jpeg", 
    "image/png",  
    "application/pdf",
    "application/msword",  
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  if (file) {
    // Check if the file type is valid
    if (!allowedTypes.includes(file.type)) {
      this.fileError = "Only JPG, JPEG, PNG, PDF, DOC, and DOCX files are allowed.";
      this.agreement = null;
    } else {
      this.fileError = "";
      this.agreement = file;
    }
  }
},
 async fetchBankDetail() {
      try {
        const responseData = await NetworkService.get("bank-list");
        this.bankData = responseData;
      } catch (error) {
        this.$refs.toast.show("Unable to fetching bank details", "error");
      }
    },
      onBankSelect() {
  if (this.bankName && this.bankName.ifsc_code) {
    this.ifscCode = this.bankName.ifsc_code;
  } else {
    this.ifscCode = "";
    this.branch = "";
  }
},
    submitRentalPayment() {
      this.validator
        .$validate()
        .then(async (isValid) => {
          if (!isValid) return Promise.reject();
          if (!this.agreement) {
            this.$refs.toast.show("Please upload a valid invoice document.", "error");
            return;
          }
          this.showaddadminSpinner = true;
        const formData = new FormData();
      formData.append('service_id',this.serviceId);
      formData.append('user_id',this.userId)
      formData.append('name', this.name);
      formData.append('mobile', this.mobile);
      formData.append('pan_number', this.pan);
      formData.append('address', this.address);
      formData.append('amount', this.monthlyRent);
      formData.append('document', this.agreement);
      formData.append("account_number", this.accountNumber);
      formData.append("account_holder_name", this.accountHolderName),
      formData.append("bank_name", this.bankName?.bank_name),
      formData.append("bank_branch", this.branch),
      formData.append("ifsc_code", this.ifscCode);
      try {
        const res = await NetworkService.post('/store-service-list', formData, {
         headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
         console.log("res",res);
        this.$refs.toast.show("Vendor payment details added successfully.");
        this.showaddadminSpinner = false;
        setTimeout(() => {
          this.$router.back();
        }, 3000);
      } catch (error) {
        this.showaddadminSpinner = false;
         const errorMessage =
              error?.message || "Unable to adding the vendor details.";
            this.$refs.toast.show(errorMessage, "error");
      }
    })
    .catch((error) => {
        this.showaddadminSpinner = false;
      this.$refs.toast.show(ErrorService.getErrorMessages(error), "error");
    });
    },
  },
};
</script>
